module.exports = __webpack_public_path__ + "100b38fa184634fc89bd07a84453992c.ttf";